export default __webpack_public_path__ + "static/s07-13c21a9b09ce65a602190465005d8a3c.png";